import ClosureList from './ClosureList.vue';

export default ClosureList;
